import React, { useState, useContext } from 'react';
import axios from 'axios';
import configData from '../../../config.json';
import Wheel from './Wheel';
import SelectSevenSection from './SelectSevenSection';
import ModalSevenConfirm from './TemplateGoals/ModalSevenConfirm';
import PickSevenV2 from '../../PortalV2/Steps/Goals/PickSevenV2';
import Header from '../Header/Header';
import './OolaSevenSection.css';
import AppContext from '../../../Context/AppContext';

const readGoalId = (item) => {
    if (!item) return null;
    const id = item.GoalId ?? item.goalId ?? item.Id ?? item.id ?? null;
    const n = Number(id);
    return Number.isFinite(n) && n > 0 ? n : null;
};

const findSourceGoal = (pick, selectedGoals) =>
    (selectedGoals || []).find(
        (g) =>
            g.areaId === pick.areaId &&
            g.recomendationIndex === pick.recomendationIndex
    );

const resolvePickGoalId = (pick, selectedGoals) => {
    const direct = readGoalId(pick);
    if (direct) return direct;
    return readGoalId(findSourceGoal(pick, selectedGoals));
};

function syncSelectedGoalsGroupGoalIds(allState) {
    const selectedGoals = allState.SelectedGoals || [];
    const group = allState.SelectedGoalsGroup;
    if (!group) return;

    selectedGoals.forEach((g) => {
        const goalId = readGoalId(g);
        if (!goalId) return;
        const slot = group[g.areaId]?.selected?.find(
            (s) => s.recomendationIndex === g.recomendationIndex
        );
        if (slot) slot.GoalId = goalId;
    });

    (allState.SelectedGoalsSeven || []).forEach((pick) => {
        const goalId = resolvePickGoalId(pick, selectedGoals);
        if (goalId) pick.GoalId = goalId;
    });
}

const OolaSevenSection = (props) => {
    const { checkUserSession, changeLoading } = useContext(AppContext);
    const currUser = checkUserSession();

    const AllProps = { ...props.AllState };
    if (!props.portalV2) {
        AllProps.CurrentF = 0;
    }

    const [showSevenConfirm, setShowSevenConfirm] = useState(false);
    const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
    const [continueError, setContinueError] = useState('');
    const [confirmObj] = useState({
        ModalConfirmTitle: 'YOUR 7 GOALS ARE SELECTED',
        ModalConfirmDesc:
            "Next, you'll rank these goals by priority so you can focus on what matters most.",
    });

    function confirmGoals() {
        setContinueError('');

        const picks = [...(props.AllState.SelectedGoalsSeven || [])]
            .filter(Boolean)
            .slice(0, 7);

        if (picks.length !== 7) {
            return;
        }

        syncSelectedGoalsGroupGoalIds(props.AllState);

        const resolvedGoals = picks.map((pick) => ({
            pick,
            goalId: resolvePickGoalId(pick, props.AllState.SelectedGoals),
        }));

        const advanceToArrange = () => {
            setShowSevenConfirm(false);
            if (currUser.userStepId != 7 && props.handleChangeHeader) {
                props.handleChangeHeader(1);
            }
            const picksWithIds = resolvedGoals.map(({ pick, goalId }) => ({
                ...pick,
                GoalId: goalId ?? pick.GoalId,
            }));
            try {
                sessionStorage.setItem(
                    'pv2-top7-picks',
                    JSON.stringify(picksWithIds)
                );
            } catch {
                /* ignore */
            }
            props.changeData((prev) => ({
                ...prev,
                SelectedGoalsSeven: picksWithIds,
                CurrentStep2: (Number(prev.CurrentStep2) || 0) + 1,
                changeData: props.changeData,
            }));
            window.scrollTo(0, 0);
        };

        const missingIds = resolvedGoals.some(({ goalId }) => !goalId);
        if (missingIds) {
            if (props.portalV2) {
                advanceToArrange();
                return;
            }
            setContinueError(
                'Some goals are not saved yet. Go back to the previous step and save all 21 goals before continuing.'
            );
            return;
        }

        changeLoading(true);
        const PostObj = {
            Goals: resolvedGoals.map(({ goalId }) => ({
                GoalId: goalId,
                SevenGoalOrder: 0,
            })),
        };

        const url = `${configData.SERVER_URL}Goals/SetSevenGoalsOrder`;

        axios
            .put(url, PostObj, {
                headers: {
                    Authorization: `Bearer ${currUser.token}`,
                },
            })
            .then(() => {
                changeLoading(false);
                advanceToArrange();
            })
            .catch((error) => {
                console.log(error);
                changeLoading(false);
                if (props.portalV2) {
                    advanceToArrange();
                    return;
                }
                const apiMsg =
                    typeof error?.response?.data === 'string'
                        ? error.response.data
                        : 'Unable to save your Top 7 goals. Please try again.';
                setContinueError(apiMsg);
            });
    }

    if (typeof props.AllState.SelectedGoalsGroup === 'undefined') {
        const newObject = {};
        (props.AllState.SelectedGoals || []).forEach((x) => {
            if (!Object.prototype.hasOwnProperty.call(newObject, x.areaId)) {
                newObject[x.areaId] = {
                    Fs: AllProps.Fs[x.areaId],
                    selected: [],
                };
            }
            newObject[x.areaId].selected.push({
                areaId: x.areaId,
                date: x.date,
                recomendationIndex: x.recomendationIndex,
                text: x.text,
                selected: !!x.selected,
                Id: x.Id,
                GoalId: readGoalId(x),
            });
        });

        props.AllState.SelectedGoalsGroup = newObject;
        props.changeData(props.AllState);
    } else {
        syncSelectedGoalsGroupGoalIds(props.AllState);
    }

    if (props.portalV2) {
        return (
            <div className="pv2-step2-glass">
                <PickSevenV2
                    AllState={props.AllState}
                    changeData={props.changeData}
                    confirmGoals={confirmGoals}
                    forceUpdate={props.forceUpdate}
                />
            </div>
        );
    }

    return (
        <>
            <Header
                data={(props.AllState.Fs || []).map((item) => ({
                    id: item.areaId,
                    name: item.name,
                    tabColor: item.color,
                }))}
                AllState={props.AllState}
                pick7Browse
                activeCategoryIndex={activeCategoryIndex}
                onSelectCategory={setActiveCategoryIndex}
            />
            <section className="selectGoalTop7__container">
            <div className="selectGoalTop7__wrapper">
                <div className="selectGoalTop7__wrapperWheel">
                    <Wheel
                        AllState={props.AllState}
                        hideNav={false}
                        allColors
                        pick7Browse
                        activeCategoryIndex={activeCategoryIndex}
                        onSelectCategory={setActiveCategoryIndex}
                    />
                </div>
                <div>
                    <SelectSevenSection
                        updateIndexStep2={props.updateIndexStep2}
                        forceUpdate={props.forceUpdate}
                        AllState={props.AllState}
                        changeData={props.changeData}
                        hideNav={false}
                        confirmGoals={confirmGoals}
                        setShowSevenConfirm={setShowSevenConfirm}
                        activeCategoryIndex={activeCategoryIndex}
                        setActiveCategoryIndex={setActiveCategoryIndex}
                        continueError={continueError}
                    />
                </div>
            </div>
            <ModalSevenConfirm
                confirmGoals={confirmGoals}
                show={showSevenConfirm}
                setShowSevenConfirm={setShowSevenConfirm}
                ModalConfirmTitle={confirmObj.ModalConfirmTitle}
                ModalConfirmDesc={confirmObj.ModalConfirmDesc}
            />
        </section>
        </>
    );
};

export default OolaSevenSection;
